import styleFooter from "./Footer.module.css";
import logoFooter from '../../assets/img/logoFooter.png';
const Footer = () => {
  return (
    <div className={styleFooter.footer}>
      <div className="d-flex flex-row flex-nowrap justify-content-center align-items-center gap-2 px-3 py-2">
        <p className={styleFooter.text}>
          جميع الحقوق محفوظة مصلحة الضرائب العقارية. مدعوم بـواسطة
        </p>
        <img src={logoFooter} alt="etax imagefooter" width="60" />
      </div>
    </div >
  );
};

export default Footer;